import React, {useEffect, useRef} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import {withSitecoreRouter} from 'utils/withRouter';
import './meridianMap.component.scss';
import * as mapHelper from './actions/mapHelper';
import * as mapActions from './actions/mapActions';
import ExhibitorModal from './components/exhibitorModal';
import mapReducer from './reducers/mapreducer';
import { createAppState } from 'modules/redux-app-state';
import MeridianMapInner from './components/meridianMap';

const DEFAULT_MAP_HEIGHT = "500px";

const MeridianMap = (props) => {
    const theState = createAppState();
    const isAvailable = useRef(false);

    const getID = () => "meridian-map-".concat(!!props.ID ? props.ID : "1");

    useEffect(() => {
        let isMounted = true;
        theState.reducerRegistry.register({ mapReducer });
        isAvailable.current = typeof window !== "undefined" && window.location.search;
        mapHelper.GetFloors(props.locationID).then(floors => {
            const newFloorID = mapHelper.GetFloorIDFromBuilding(floors, props.buildingName, props.floorNo)
            if (newFloorID != props.floorId) props.mapActions.setMapData(newFloorID, floors);
        });
        checkForHighlightedIcon();
        return () => {
            if (theState.reducerRegistry.unregister) theState.reducerRegistry.unregister("mapReducer");
            isMounted = false;
            props.mapActions.setMapData(null, null);
        }
    }, []);

    useEffect(() => {
        if (!!props.floorNo && !!props.buildingName && !!props.floors) {
            const newFloorID = mapHelper.GetFloorIDFromBuilding(props.floors, props.buildingName, props.floorNo);
            if (newFloorID != props.floorId) props.mapActions.setFloorID(newFloorID);
        }
    }, [props.floorNo, props.buildingName, props.floors]);

    const checkForHighlightedIcon = () => {
        const highlightIcon = props.highLightPlacemarkId;
        const locationId = props.locationID;
        const building = props.buildingName;
        const floorNo = props.floorNo;
        let retries = 0;

        const checkMapDomUpdated = (iconId) => {
            //finds the element for the placemarkID
            const el = document.querySelector(`button[data-meridian-placemark-id='${iconId}']`);
            if (!!el && isMounted) {
                el.classList.add("bounce");
            } else {
                retries++;
                console.log("retry");
                if (retries < 10) {
                    setTimeout(() => {
                        checkMapDomUpdated(iconId);
                    }, 2500);
                }
            }
        }

        if (!!highlightIcon) {
            //set an event to look for the corresponding placemark and highlight it.
            mapHelper.GetPlacemark(locationId, highlightIcon, building, floorNo).then(p => {
                if (!!p) {
                    const placemarkId = p.id.split('_')[1];
                    //waits for the placemarks dom to be generated and then tries to highlight the right  placemark
                    setTimeout(() => {
                        checkMapDomUpdated(placemarkId);
                    }, 2500);
                } else
                    console.warn("MAP - PlacemarkID  not found for the provided UID");
            });
        }
    }

    const checkParameters = () => {
        const locationId= props.locationID;
        const building= props.buildingName;
        const floorNo= props.floorNo;

        return (!!locationId && !!building && !!floorNo);
    };

    const closePopUp = () =>{
        props.mapActions.closeExhibitorDetails();
    }

    const building = props.buildingName;
    const floorNo = props.floorNo;

    if (!checkParameters()) {
        return (<p>Building / Floor / Location Parameters missing</p>);
    }

    return (
        <div style={{display: 'flex'}}>
            <div className="imc-map-container" style={{minHeight: !!props.height ? props.height : DEFAULT_MAP_HEIGHT}}>
                <div className={!!props.selectedEx ? "imc-meridian-map" : ""} id={getID()}>
                </div>
                <MeridianMapInner
                    {...props}
                    floorId={props.floorId}
                />
            </div>

            {
                !!props.showExModal &&
                props.selectedEx &&
                <ExhibitorModal exhibitor={props.selectedEx}
                    building={building}
                    floorNo={floorNo}
                    maxHeight={!!props.height ? props.height : DEFAULT_MAP_HEIGHT}
                    closePopup={closePopUp}
                />
            }
        </div>
    )
}

function mapStateToProps(state) {
    if (!!state.mapReducer)
    {
        return {
            floors: state.mapReducer.floors,
            floorId: state.mapReducer.floorId,
            map: state.mapReducer.map,
            showExModal: state.mapReducer.showExModal,
            selectedEx: state.mapReducer.selectedEx,
        }}
    else {
        return {
            floors: state.floors,
            floorId: state.floorId,
            map: state.map,
            showExModal: state.showExModal,
            selectedEx: state.selectedEx,
        };
    }
}

function mapDispatchToProps(dispatch) {
    return {
        mapActions: bindActionCreators({ ...mapActions }, dispatch),
    };
}

const meridianSrc=(process.env.PUBLIC_URL!==undefined?process.env.PUBLIC_URL:'/dist/las-vegas-market') + "/meridian-sdk.js";

export default withSitecoreContext()(withSitecoreRouter(connect(mapStateToProps, mapDispatchToProps)(MeridianMap)));
